import { ENDPOINTS } from '../config'
import type { AxiosResponse } from 'axios'
import type { PostGetCurrentUserResInterface } from '../types/PostGetCurrentUserResInterface'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const postGetCurrentUser = (): Promise<
  AxiosResponse<PostGetCurrentUserResInterface>
> => {
  return AuthAxios.get(ENDPOINTS.ENDPOINT_POST_GET_CURRENT_USER)
}

export default postGetCurrentUser
